module.exports = __webpack_public_path__ + "assets/516b1484f0942e0267b3b474c0c89486.png";